import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';

export class AgentReportCreateDto extends BaseModel {
  @Expose()
  name!: string;
}

export class AgentReportUpdateDto extends BaseModel {
  @Expose()
  name!: string;
}
